<template>
    <main class="main ">
        <div class="container">
            <h2 class="h2 my-3">Stan gotówki w kasie</h2>
            <div class="cash-amount" v-if="companiesCashAmount&&companiesCashAmount.length>0">
                <ui-data-table headers-on-mobile v-if="tableData" mobile-striped  :tableData="tableData"/>
            </div>
            <div v-else>Brak wyników</div>
        </div>
    </main>
</template>

<script>
import { UiDataTable } from '../components/global/ui'
import CashAmountActionButton from '../components/services/cash-amount/CashAmountActionButton.vue'
import CashAmountTerminals from '../components/services/cash-amount/CashAmountTerminals.vue'
export default {
    name: 'CashAmountView',
    components: { UiDataTable },
    computed: {
        companiesCashAmount() {
            return this.$store.getters.getCompaniesCashAmount
        }
    },
    watch: {
        companiesCashAmount(companies) {
            if(!companies) return
            const tableData = {
                head: [],
                body: []
            }
            companies.forEach((company, companyIdx) => {
                tableData.head = ['Nazwa', 'Adres sklepu', 'Liczba kas']
                tableData.body.push([
                    { text: `${company.name}`, customClass: 'text-primary' },
                    company.address,
                    `${company.count_of_devices}`,
                    {
                        type: 'hidden',
                        data: { id: companyIdx }
                    },
                    {
                        type: 'component',
                        component: CashAmountActionButton,
                        mode: 'action',
                        config: {
                            arrowUp: false,
                            text: 'Zaakceptuj',
                            onClick: () => {
                                const show = !this.tableData.body[companyIdx].find(e => e.type && e.type === 'expanded').show
                                this.tableData.body[companyIdx].find(e => e.type && e.type === 'expanded').show = show
                                this.tableData.body[companyIdx].find(e => e.type && e.type === 'component' && e.mode === 'action').config.arrowUp = show
                            }
                        }
                    },
                    {
                        type: 'expanded',
                        component: CashAmountTerminals,
                        show: false,
                        componentConfig: {
                            terminals: company.terminals
                        }
                    }
                ])
            })

            this.tableData = tableData
        }
    },
    beforeMount() {
        this.$store.dispatch('fetchCashAmount')
    },
    data() {
        return{
            tableData: null
        }
    }

}
</script>
